document.addEventListener('DOMContentLoaded', () => {
    const footer = document.querySelector('.site-footer');

    if ( footer != null ) {
        const links = footer.querySelectorAll('.link--animated');

        for (let link of links ) {
            if ( link.getAttribute('href') == "/#chat" ) {
                link.href = "";
                link.addEventListener('click', (e) => handleChatClick(e))
            }
        }
    }
})

function handleChatClick(e) {
    e.preventDefault() 
    const chatElement = document?.getElementById(`ShopifyChat`)?.shadowRoot?.querySelector(`.chat-app>button`) 
    if ( chatElement != null ) {
        chatElement.click() 
    }
}